import * as React from 'react'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

import { AuthSection, AuthSectionProps } from '../../AuthSection'
import { SearchDrawer } from '../../drawers/SearchDrawer'
import * as S from '../../style'

type RightZoneProps = {
  search: {
    action: string
  }
} & AuthSectionProps

export function Crowdfunding({ loadUserExtraData, search, user }: RightZoneProps): React.ReactElement<RightZoneProps> {
  const $separator = React.useRef<HTMLDivElement>(null)

  return (
    <>
      <SearchDrawer
        action={search.action}
        siblingRef={$separator}
        user={user ? { unreadMessagesCount: user.unreadMessagesCount } : undefined}
      />
      <SeparatorContainer ref={$separator} />
      <AuthSection loadUserExtraData={loadUserExtraData} user={user} />
    </>
  )
}

const SeparatorContainer = styled.div`
  padding: 0 22px 0 0;
  visibility: hidden;

  @media screen and ${S.INTERMEDIATE_BREAKPOINT} {
    visibility: visible;
  }
`
